import React from 'react';
import { Modal } from 'react-native';

import { Button, Center, Heading, Text, VStack, theme } from '@squire/ui';

import { CloseIcon } from '@/components/_icons';
import { SpinnerInline } from '@/components/_shared/SpinnerInline';

import { styles } from './styles';
import type { FullScreenLoadingProps } from './types';

const FullScreenLoading = ({
  isLoading,
  isError,
  errorTitle,
  errorMessage,
  onReset,
  processingText,
  resetText,
  ...props
}: FullScreenLoadingProps) => {
  return (
    <Modal
      transparent={false}
      animationType="fade"
      visible={isLoading || isError}
      {...props}
    >
      <VStack
        flex
        centerHorizontal
        centerVertical
        space={theme.spacing[3]}
        paddingHorizontal={theme.spacing[4]}
      >
        {isError ? (
          <VStack centerHorizontal space={theme.spacing[8]}>
            <Center style={styles.errorIconContainer}>
              <CloseIcon color="iconPrimaryInverse" size={32} />
            </Center>

            <VStack centerHorizontal space={theme.spacing[3]}>
              <Heading variant="l" align="center" numberOfLines={3}>
                {errorTitle ?? errorMessage}
              </Heading>

              {errorTitle && errorMessage ? (
                <Text variant="m" style={styles.errorDescription}>
                  {errorMessage}
                </Text>
              ) : null}
            </VStack>

            <Button
              onPress={onReset}
              variant="secondary"
              style={styles.resetButton}
            >
              {resetText}
            </Button>
          </VStack>
        ) : (
          <>
            <Heading variant="l" align="center">
              {processingText}
            </Heading>
            <SpinnerInline />
          </>
        )}
      </VStack>
    </Modal>
  );
};

FullScreenLoading.displayName = 'FullScreenLoading';
export { FullScreenLoading };
